import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
// JS bundle (includes Popper) - needed for the navbar's mobile collapse
// toggle in App.jsx; everything else we use (cards, tables, buttons,
// spinners) is CSS-only and doesn't need this.
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './styles.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
